/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Booking_Times_Code_Example_2Inputs */

const en_admin_resource_form_booking_times_code_example_2 = /** @type {(inputs: Admin_Resource_Form_Booking_Times_Code_Example_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mo - fr 9:00 - 18:30, sa - su 10:00 - 16:00`)
};

const de_admin_resource_form_booking_times_code_example_2 = /** @type {(inputs: Admin_Resource_Form_Booking_Times_Code_Example_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mo - fr 9:00 - 18:30, sa - su 10:00 - 16:00`)
};

const es_admin_resource_form_booking_times_code_example_2 = /** @type {(inputs: Admin_Resource_Form_Booking_Times_Code_Example_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mo - fr 9:00 - 18:30, sa - su 10:00 - 16:00`)
};

const fr_admin_resource_form_booking_times_code_example_2 = /** @type {(inputs: Admin_Resource_Form_Booking_Times_Code_Example_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lun - Ven 9:00 - 18:30, Sam - Di 10:00 - 16:00`)
};

/** @type {(inputs: Admin_Resource_Form_Booking_Times_Code_Example_2Inputs) => LocalizedString} */
const it_admin_resource_form_booking_times_code_example_2 = en_admin_resource_form_booking_times_code_example_2;

/** @type {(inputs: Admin_Resource_Form_Booking_Times_Code_Example_2Inputs) => LocalizedString} */
const pt_br2_admin_resource_form_booking_times_code_example_2 = en_admin_resource_form_booking_times_code_example_2;

/** @type {(inputs: Admin_Resource_Form_Booking_Times_Code_Example_2Inputs) => LocalizedString} */
const pl_admin_resource_form_booking_times_code_example_2 = en_admin_resource_form_booking_times_code_example_2;

/** @type {(inputs: Admin_Resource_Form_Booking_Times_Code_Example_2Inputs) => LocalizedString} */
const hu_admin_resource_form_booking_times_code_example_2 = en_admin_resource_form_booking_times_code_example_2;

/** @type {(inputs: Admin_Resource_Form_Booking_Times_Code_Example_2Inputs) => LocalizedString} */
const ro_admin_resource_form_booking_times_code_example_2 = en_admin_resource_form_booking_times_code_example_2;

/**
* | output |
* | --- |
* | "mo - fr 9:00 - 18:30, sa - su 10:00 - 16:00" |
*
* @param {Admin_Resource_Form_Booking_Times_Code_Example_2Inputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_booking_times_code_example_2 = /** @type {((inputs?: Admin_Resource_Form_Booking_Times_Code_Example_2Inputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Booking_Times_Code_Example_2Inputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_booking_times_code_example_2(inputs)
	if (locale === "de") return de_admin_resource_form_booking_times_code_example_2(inputs)
	if (locale === "es") return es_admin_resource_form_booking_times_code_example_2(inputs)
	if (locale === "fr") return fr_admin_resource_form_booking_times_code_example_2(inputs)
	if (locale === "it") return it_admin_resource_form_booking_times_code_example_2(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_booking_times_code_example_2(inputs)
	if (locale === "pl") return pl_admin_resource_form_booking_times_code_example_2(inputs)
	if (locale === "hu") return hu_admin_resource_form_booking_times_code_example_2(inputs)
	return ro_admin_resource_form_booking_times_code_example_2(inputs)
});
export { admin_resource_form_booking_times_code_example_2 as "admin.resource_form.booking_times_code_example_2" }